import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SsoAuthService } from '../../services/sso-auth.service';
import { Router } from '@angular/router';
import { UiService } from '../../services/ui.service';

@Component({
  selector: 'app-sso-login',
  templateUrl: './sso-login.component.html',
  styleUrls: ['./sso-login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SsoLoginComponent implements OnInit {

  constructor(private sso: SsoAuthService, private router: Router) { }

  ngOnInit() {

    const authUser = this.sso.getAuthUser();
    if (authUser) {
      this.router.navigate(['/ssoauth']);
    }

  }

}
